const ruRU = {
    crossmintPayButtonService: {
        CONNECTING: "Подключение...",
        BUY: "Купить с помощью Crossmint",
        BUY_WITH_ETH: "Купить за ETH",
        BUY_WITH_SOL: "Купить за SOL",
        BUY_WITH_CREDIT_CARD: "Купить с помощью кредитной карты",
    },
};
export default ruRU;
